import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const TriangleDownIcon = createIcon(
  'TriangleDown',
  // @todo replace with path
  <polygon points="12 6 20 18 4 18" />
);

TriangleDownIcon.warning = true;

export default TriangleDownIcon;
